"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var theme = {
    fontWeight: {
        medium: 500,
        bold: 700,
    },
    borderRadius: {
        light: '2px',
        normal: '3px',
        curvy: '4px',
        round: '20px',
    },
    boxShadow: {
        default: '0px 1px 4px rgba(0, 0, 0, 0.25)',
        hover: '0px 1px 8px #4170A3',
    },
    colors: {
        pureWhite: '#fff',
        pureBlack: '#000',
        lqBlue: '#154B82',
        spaceBlack: '#303840',
        offWhite: '#F5F7FA',
        darkBlue: '#002759',
        marinoBlue: '#4170A3',
        lightBlue: '#B6D6EC',
        paleBlue: '#E7F0F8',
        slateGray: '#657787',
        regentGray: '#8595A6',
        heatherGray: '#B4C2D1',
        iceGray: '#E4EBF2',
        megaOrange: '#BE5709',
        lqOrange: '#F57E25',
        lightOrange: '#FFBE73',
        okGreen: '#318243',
        uhohYellow: '#FFA540',
        warningRed: '#FF4545',
        basicRed: '#EA0606',
    },
};
exports.theme = theme;
//# sourceMappingURL=index.js.map